import {
  IAttribute,
  ICreateAttribute,
  IUpdateAttribute,
} from '../interfaces/IAttribute';

export class AttributeMapper {
  /**
   * Maps attribute data to select options format
   */
  static toSelect(attributes: IAttribute[]) {
    return (attributes || []).map((attribute) => ({
      label: attribute.name,
      value: String(attribute.id),
    }));
  }

  /**
   * Maps attributes to simple list format (id, name only)
   */
  static toList(attributes: IAttribute[]) {
    return (attributes || []).map((attribute) => ({
      id: attribute.id,
      name: attribute.name,
    }));
  }

  /**
   * Maps attributes array to object with id as key
   */
  static toObject(attributes: IAttribute[]) {
    return (attributes || []).reduce((acc, attribute) => {
      acc[attribute.id] = {
        id: attribute.id,
        name: attribute.name,
        type: attribute.type,
        code: attribute.code,
        unit: attribute.unit,
      };
      return acc;
    }, {} as Record<number, Pick<IAttribute, 'id' | 'name' | 'type' | 'code' | 'unit'>>);
  }

  /**
   * Maps single attribute from API to UI format
   */
  static toLocal(attribute: IAttribute): IAttribute {
    return {
      ...attribute,
      unit: attribute.unit ?? null,
      isRequired: attribute.isRequired ?? false,
      sortOrder: attribute.sortOrder ?? 0,
      isActive: attribute.isActive,
      validation: attribute.validation ?? null,
      options: attribute.options ?? null,
      meta: attribute.meta ?? {},
      createdAt: attribute.createdAt,
      updatedAt: attribute.updatedAt,
    };
  }

  /**
   * Maps attributes array to UI format
   */
  static toListUI(attributes: IAttribute[]): IAttribute[] {
    return (attributes || []).map((attribute) => this.toLocal(attribute));
  }

  /**
   * Maps form data to API create/update request format
   */
  static toCreateRequest(data: ICreateAttribute): ICreateAttribute {
    return {
      name: data.name,
      entityType: data.entityType,
      type: data.type,
      unit: data.unit || null,
      isRequired: data.isRequired ?? false,
      sortOrder: data.sortOrder ?? 0,
      isActive: data.isActive ?? true,
      validation: data.validation ?? null,
      options: data.options ?? null,
      meta: data.meta ?? null,
    };
  }

  /**
   * Maps form data to API update request format
   */
  static toUpdateRequest(_id: number, data: IUpdateAttribute): IUpdateAttribute {
    return {
      name: data.name,
      entityType: data.entityType,
      type: data.type,
      unit: data.unit,
      isRequired: data.isRequired,
      sortOrder: data.sortOrder,
      isActive: data.isActive,
      validation: data.validation,
      options: data.options,
      meta: data.meta,
    };
  }
}

